import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { PartnerListInterface } from '../types/partner-list';
import { PartnerListFilter } from '../types/partner-list-filter';

export const fetchPartnerList = createAction(
  '[Partner List] Partner List Fetch',
  props<{ filter?: PartnerListFilter }>()
);

export const updatePartnerListFilter = createAction(
  '[Partner Filter] Partner List update filter',
  props<{ filter?: PartnerListFilter }>()
);

export const loadedPartnerList = createAction(
  '[Partner List] Partner List Loaded',
  props<{ dataSource: DataSource<PartnerListInterface[]> }>()
);

export const failedPartnerList = createAction(
  '[Partner List] Partner List Failed'
);

export const deletePartner = createAction(
  '[Partner List] Delete Partner',
  props<{ partner_id: number }>()
);

export const resetPartnerList = createAction(
  '[Partner List] Reset Partner List'
);
